import React from "react";
import Employees from "../modules/BiometricFace/Employees";
export default function BiometricFacePage() {
  return <Employees />;
}
